import React from 'react';
import { IAvatarProps } from '../../Base/Avatar/Avatar';

import { Avatar, Button, Card, CardBody, CardText, CardTitle } from '../..';

export interface IFileCardProps {
  fileName?: string;
  filePath?: string;
  thumbnailUrl?: string;
  fileType?: string;
  fileSize?: string;
  fileUploader?: string;
  created?: string;
  downloadable?: boolean;
  size?: IAvatarProps['size'];
}

export const FileCard: React.FunctionComponent<IFileCardProps> = (props) => {
  return (
    <Card className="m-2">
      <CardBody>
        <div className="row align-items-center">
          <div className="col-auto">
            <Avatar src={props.thumbnailUrl} size={props.size} rounded />
          </div>
          <div className="col ml-n2">
            <CardTitle>{props.fileName}</CardTitle>
            {props.fileType && (
              <CardText muted small className="mb-1">
                {props.fileType}
              </CardText>
            )}
            {props.fileSize && (
              <CardText muted small className="mb-1">
                {props.fileSize}
              </CardText>
            )}
            {(props.fileUploader || props.created) && (
              <CardText muted small>
                Uploaded {props.fileUploader && `by ${props.fileUploader} `}
                {props.created &&
                  `on ${new Date(props.created).toLocaleDateString()}`}
              </CardText>
            )}
          </div>
          <div className="col-auto">
            {props.downloadable && (
              <Button variant="white" size="sm">
                Download
              </Button>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
